import { createAction } from "redux-actions";
import { createPromiseAction } from "../../utils/createPromiseAction";

export const GET_QUIZ_REQUEST = "brand/GET_QUIZ_REQUEST";
export const GET_QUIZ_SUCCESS = "brand/GET_QUIZ_SUCCESS";
export const ANSWER_QUIZ_REQUEST = "brand/ANSWER_QUIZ_REQUEST";
export const ANSWER_QUIZ_SUCCESS = "brand/ANSWER_QUIZ_SUCCESS";

export const quizActions = {
  getQuiz: createPromiseAction(GET_QUIZ_REQUEST),
  getQuizSuccess: createAction(GET_QUIZ_SUCCESS),
  answerQuiz: createPromiseAction(ANSWER_QUIZ_REQUEST),
  answerQuizSuccess: createAction(ANSWER_QUIZ_SUCCESS),
};
